module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row well"
  }, [_c('table', {
    staticClass: "table"
  }, _vm._l((_vm.ageList), function(age) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (age.isSelected),
        expression: "age.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.parentFormName + age.selectId
      },
      domProps: {
        "value": age.isSelected,
        "checked": Array.isArray(age.isSelected) ? _vm._i(age.isSelected, age.isSelected) > -1 : (age.isSelected)
      },
      on: {
        "change": function($event) {
          var $$a = age.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = age.isSelected,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (age.isSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (age.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(age, "isSelected", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.parentFormName + age.selectId
      }
    }, [_vm._v(_vm._s(age.description))])])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (age.isSelected),
        expression: "age.isSelected"
      }],
      staticStyle: {
        "width": "10%"
      }
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (age.isSurface),
        expression: "age.isSurface"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.parentFormName + 'surface' + age.selectId
      },
      domProps: {
        "value": age.isSurface,
        "checked": Array.isArray(age.isSurface) ? _vm._i(age.isSurface, age.isSurface) > -1 : (age.isSurface)
      },
      on: {
        "change": function($event) {
          var $$a = age.isSurface,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = age.isSurface,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (age.isSurface = $$a.concat([$$v]))
            } else {
              $$i > -1 && (age.isSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(age, "isSurface", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.parentFormName + 'surface' + age.selectId
      }
    }, [_vm._v("Surface")])])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (age.isSelected),
        expression: "age.isSelected"
      }],
      staticStyle: {
        "width": "10%"
      }
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (age.isSubsurface),
        expression: "age.isSubsurface"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.parentFormName + 'subsurface' + age.selectId
      },
      domProps: {
        "value": age.isSubsurface,
        "checked": Array.isArray(age.isSubsurface) ? _vm._i(age.isSubsurface, age.isSubsurface) > -1 : (age.isSubsurface)
      },
      on: {
        "change": function($event) {
          var $$a = age.isSubsurface,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = age.isSubsurface,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (age.isSubsurface = $$a.concat([$$v]))
            } else {
              $$i > -1 && (age.isSubsurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(age, "isSubsurface", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.parentFormName + 'subsurface' + age.selectId
      }
    }, [_vm._v("Subsurface")])])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (age.isSelected && _vm.phaseFilter(age.selectId).length > 0),
        expression: "age.isSelected && phaseFilter(age.selectId).length > 0"
      }]
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (age.prehistoricPhaseId),
        expression: "age.prehistoricPhaseId"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "150px"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(age, "prehistoricPhaseId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select a phase")]), _vm._v(" "), _vm._l((_vm.phaseFilter(age.selectId)), function(phase) {
      return _c('option', {
        domProps: {
          "value": phase.prehistoricPhaseId
        }
      }, [_vm._v("\n                            " + _vm._s(phase.description) + "\n                        ")])
    })], 2)])])
  })), _vm._v(" "), (_vm.isDebug) ? _c('div', [_c('pre', [_vm._v("            Prehistoric? " + _vm._s(_vm.isPrehistoric) + "\n           ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a4878cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/ageSelection.vue
// module id = 977
// module chunks = 1